import { Flex, Skeleton, Text } from '@mantine/core';
import { useTranslationMipMessages } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { StatusWithIcon } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/StatusWithIcon/StatusWithIcon';
import { EmailSentEventStatusResponse } from '@dealstack/shared/lib/generated';

interface Props {
	fullName: string;
	email: string;
	sentDate: string;
	status: EmailSentEventStatusResponse;
	isLoading: boolean;
}

export const DetailedMessageHeader = ({ fullName, email, sentDate, status, isLoading }: Props) => {
	const tMipMessages = useTranslationMipMessages();

	return (
		<Flex justify="space-between" w="100%">
			<Flex direction="column">
				<Text fw={600} size="1.125rem">
					{tMipMessages('messageSent')}
				</Text>
				{isLoading ? (
					<Skeleton height={20} />
				) : (
					<Text size="md">{`${fullName} (${email})`}</Text>
				)}
			</Flex>
			<Flex direction="column">
				{isLoading ? (
					<Skeleton>
						<StatusWithIcon
							status={EmailSentEventStatusResponse.UNKNOWN}
							fontWeight={600}
							textSize={18}
						/>
						<Text size="md">{new Date().toDateString()}</Text>
					</Skeleton>
				) : (
					<>
						<StatusWithIcon status={status} fontWeight={600} textSize={18} />
						<Text size="md">{sentDate}</Text>
					</>
				)}
			</Flex>
		</Flex>
	);
};
